<template>
  <div>
    <div class="filter-bar mb-sm">
      <breadcrumb></breadcrumb>

      <div class="space"></div>

      <el-button size="small" type="primary" @click="onView"
        >查看教研手册</el-button
      >
      <el-button slot="reference" size="small" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>
    <div v-loading="loading" class="content-box">
      <div>
        <h2 class="label">教研组名称：</h2>
        <span> {{ groupInfo?.groupName }}</span>
      </div>
      <div>
        <h2 class="label">学年：</h2>
        <span> {{ groupInfo?.schoolYear }}</span>
      </div>
      <div>
        <h2 class="label">学期：</h2>
        <span> {{ groupInfo?.schoolTerm | revertTerm }}</span>
      </div>
      <div>
        <h2 class="label">年级：</h2>
        <span> {{ groupInfo?.gradeName }}</span>
      </div>
      <div>
        <h2 class="label">学科：</h2>
        <span> {{ groupInfo?.disciplineName }}</span>
      </div>
      <div>
        <h2 class="label">组长：</h2>
        <span> {{ groupInfo?.leaderName }}</span>
      </div>
      <div>
        <h2 class="label">组别：</h2>
        <span> {{ revertType }}</span>
      </div>
      <div>
        <h2 class="label">现级别：</h2>

        <el-select
          size="small"
          v-model="groupInfo.curType"
          @change="updateGroupPlanSummary('curType')"
        >
          <el-option
            v-for="item in groupTypeOptions"
            :value="item.value"
            :label="item.label"
            :key="item.value"
          ></el-option
        ></el-select>
      </div>
      <div>
        <h2 class="label">升级(复验)时间：</h2>
        <el-date-picker
          v-model="groupInfo.upgradeDate"
          type="date"
          placeholder="选择日期"
          @change="updateGroupPlanSummary('upgradeDate')"
          value-format="yyyy-MM-dd"
          :clearable="false"
        >
        </el-date-picker>
      </div>
      <div>
        <h2 class="label">成员：</h2>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="userName" label="姓名"> </el-table-column>
        <el-table-column prop="userSex" label="性别"> </el-table-column>
        <el-table-column prop="birthday" label="出生年月"> </el-table-column>
        <el-table-column prop="userDutyDesc" label="职称（务）">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.academicTitlesDesc }}</template
          >
        </el-table-column>
        <el-table-column prop="userDutyDesc" label="学历">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.educationDesc }}
          </template>
        </el-table-column>
        <el-table-column prop="teachingAge" label="教龄">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.teachingAge }}
          </template>
        </el-table-column>
        <el-table-column prop="className" label="任课年级（班）">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.className }}</template
          >
        </el-table-column>
        <el-table-column label="任课节数">
          <template slot-scope="scope">
            {{
              scope.row.teacherArchivesDTO?.remark &&
              JSON.parse(scope.row.teacherArchivesDTO?.remark)?.teachNum
            }}</template
          >
        </el-table-column>
        <el-table-column prop="userDutyDesc" label="进修情况">
          <template slot-scope="scope">
            {{
              scope.row.teacherArchivesDTO?.remark &&
              JSON.parse(scope.row.teacherArchivesDTO.remark)?.furtherEdu
            }}</template
          >
        </el-table-column>
        <el-table-column prop="userDutyDesc" label="社会工作">
          <template slot-scope="scope">
            {{
              scope.row.teacherArchivesDTO?.remark &&
              JSON.parse(scope.row.teacherArchivesDTO.remark)?.socialWork
            }}</template
          >
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            {{
              scope.row.teacherArchivesDTO?.remark &&
              JSON.parse(scope.row.teacherArchivesDTO.remark)
                ?.researchGroupRemark
            }}</template
          >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="goEditInfo(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
              <el-button
                slot="reference"
                type="text"
                class="danger"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="编辑备注"
        :visible.sync="dialogShow"
        @closed="onDialogClose"
      >
        <el-form
          v-loading="saving"
          ref="dialogForm"
          :model="dialogForm"
          :rules="rules"
        >
          <el-form-item label="姓名" prop="userName">
            <el-input
              :bordered="false"
              readonly
              v-model="dialogForm.userName"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="userCode">
            <el-input
              :bordered="false"
              readonly
              v-model="dialogForm.userCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              clearable
              maxlength="200"
              show-word-limit
              v-model="dialogForm.remark"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-form>
        <div slot="footer" class="dialog-footer text-center">
          <el-button @click="dialogShow = false">取 消</el-button>
          <el-button type="primary" @click="onSave" :loading="saving"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { postData } from "@/http/fetch";
import { mapState } from "vuex";
import { postJson } from "../../../http/fetch";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  components: {
    Breadcrumb,
  },
  filters: {
    revertTerm(val) {
      switch (val) {
        case 1:
          return "上学期";
        case 2:
          return "下学期";
      }
    },
  },
  data() {
    return {
      groupInfo: {
        curType: "",
      },
      loading: false,
      dialogShow: false,
      saving: false,
      tableData: [],
      groupCode: "",
      dialogForm2: null,
      dialogForm: {
        userName: null,
        userCode: null,
        remark: null,
      },
      groupTypeOptions: [
        { value: "yx", label: "优秀" },
        { value: "hg", label: "合格" },
        { value: "sf", label: "示范" },
      ],
      form: {
        curTypeStatus: true,
        upgradeDateStatus: true,
      },
      rules: {
        remark: [{ required: true, message: "请输入备注", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    revertType() {
      return this.groupTypeOptions.find(
        (item) => item.value == this.groupInfo?.groupType
      )?.label;
    },
  },
  mounted() {
    if (sessionStorage.getItem("groupCode")) {
      this.groupCode = sessionStorage.getItem("groupCode");
      this.getDeatail(this.groupCode);
      this.getResearchGroupTeacherList(this.groupCode);
    }
  },
  methods: {
    async updateGroupPlanSummary(type) {
      if (!this.groupInfo[type]) {
        this.$message.warning("请选择相关内容再保存");
        return;
      } else {
        await postJson("/researchGroup/updateGroupPlanSummary", {
          groupCode: this.groupCode,
          id: this.groupInfo.id,
          operatorId: this.userInfo.userId,
          [type]: this.groupInfo[type],
        });
        this.$message.success("保存成功");
        this.getDeatail(this.groupCode);
      }
    },
    onDialogClose() {
      this.$refs.dialogForm.resetFields();
    },
    onView() {
      this.$router.push({
        name: "researchGroupHandbook",
      });
    },
    onSave() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          if (!this.dialogForm2?.teacherArchivesDTO) {
            this.$message.error("数据异常，无法保存");
            return;
          }
          postJson("/user/updateTeacherArchives", {
            id: this.dialogForm2.teacherArchivesDTO.id,
            operatorId: this.userInfo.userId,
            remark: this.dialogForm2.teacherArchivesDTO.remark
              ? JSON.stringify({
                  ...JSON.parse(this.dialogForm2.teacherArchivesDTO.remark),
                  researchGroupRemark: this.dialogForm.remark,
                })
              : JSON.stringify({
                  researchGroupRemark: this.dialogForm.remark,
                }),
            schoolCodes: this.schoolCodes,
            userId: this.dialogForm2.userId,
          })
            .then((res) => {
              this.dialogShow = false;
              this.$message.success("操作成功！");
              this.getResearchGroupTeacherList(this.groupCode);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
    goEditInfo(row) {
      this.dialogForm2 = row;
      this.dialogForm.userName = row.userName;
      this.dialogForm.userCode = row.userCode;
      if (row.teacherArchivesDTO?.remark) {
        this.dialogForm.remark = JSON.parse(
          row.teacherArchivesDTO.remark
        )?.researchGroupRemark;
      } else {
        this.dialogForm.remark = null;
      }
      this.dialogShow = true;
    },
    async getDeatail(groupCode) {
      this.loading = true;
      
      await postData("/researchGroup/getResearchGroupInfo", {
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getResearchGroupTeacherList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getResearchGroupTeacherList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.tableData = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDel(row) {
      this.saving = true;
      postData("/researchGroup/deleteResearchGroupTeacher", {
        groupCode: this.groupCode,
        userId: row.userId,
      })
        .then(() => {
          this.getResearchGroupTeacherList(this.groupCode);
          this.$message.success("删除成功！");
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  background-color: #fff;
  padding: 20px;
  > div {
    font-size: 16px;
    margin: 10px 0;
    display: flex;
    .label {
      width: 130px;
    }
  }
  &:last-child .el-table {
    display: block;
  }
}
</style>
